import React, { useState } from "react";

// SmoothImage — fades in once decoded so the page never "pops" with raw
// pixels. Drop-in replacement for <img>: same props, same behaviour.
export default function SmoothImage({
  src, alt = "", className = "", loading = "lazy",
  blurUp = true, draggable, ...rest
}) {
  const [loaded, setLoaded] = useState(false);
  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      decoding="async"
      draggable={draggable}
      onLoad={() => setLoaded(true)}
      className={`${className} transition-[opacity,filter] duration-700 ease-out ${
        loaded ? "opacity-100 blur-0" : `opacity-0 ${blurUp ? "blur-md" : ""}`
      }`}
      {...rest}
    />
  );
}
